export interface HandoffTurn {
  role: "user" | "assistant";
  text: string;
}

export const CONTACT_SUPPORT_ANCHOR = "contact-support";

export const HANDOFF_TRANSCRIPT_MAX_CHARS = 3000;
const TRUNCATION_MARK = "[earlier conversation trimmed]";

const SPEAKER: Record<HandoffTurn["role"], string> = {
  user: "Customer",
  assistant: "Repackify AI",
};

export function buildHandoffTranscript(
  turns: ReadonlyArray<HandoffTurn>,
  maxChars = HANDOFF_TRANSCRIPT_MAX_CHARS,
): string {
  const lines = turns
    .map((turn) => ({ ...turn, text: turn.text.trim() }))
    .filter((turn) => turn.text.length > 0)
    .map((turn) => `${SPEAKER[turn.role]}: ${turn.text}`);
  const transcript = lines.join("\n\n");
  if (transcript.length <= maxChars) return transcript;
  const keep = maxChars - TRUNCATION_MARK.length - 2;
  return `${TRUNCATION_MARK}\n\n${transcript.slice(transcript.length - keep)}`;
}

export function composeSupportMessage(message: string, transcript: string): string {
  const trimmed = message.trim();
  if (!transcript) return trimmed;
  return `${trimmed}\n\n---\nAsked on the support page before writing in:\n\n${transcript}`;
}

export function handoffMessageFill(
  currentMessage: string,
  previousFill: string | null,
  question: string,
): string | null {
  const current = currentMessage.trim();
  if (current && current !== previousFill) return null;
  return question;
}
